module.exports = __webpack_public_path__ + "assets/img/7.e02d0cf8.png";